<template lang="pug">
#channels-tab
  .columns.is-multiline
    .column.is-one-quarter(
        v-for="channel in channels"
        :key="channel.id"
      )
        channel-list-item(
          :channel="channel"
          @click="open(channel)"
        )
</template>

<script>
import { mapGetters } from 'vuex';
import ChannelForm from '@/components/form/ChannelForm';
import ChannelListItem from '@/components/ChannelListItem';
import Spinner from '@/components/Spinner';
import * as actions from '@/store/types/actions';
import * as getters from '@/store/types/getters';
import * as mutations from '@/store/types/mutations';

export default {
  name: 'channels-tab',
  components: {
    ChannelForm,
    ChannelListItem,
    Spinner,
  },
  computed: {
    ...mapGetters({
      account: getters.GET_ACCOUNT,
      channels: getters.GET_CHANNELS,
      mediaRefresh: getters.GET_MEDIA_REFRESH,
      mediaTab: getters.GET_MEDIA_TAB,
      mediaTags: getters.GET_MEDIA_TAGS,
    }),
    pageQuery() {
      const from = this.pagination.per * (this.pagination.page - 1);
      const payload = {
        from,
        size: this.pagination.per,
        sort: [
          { 'title.raw': 'asc' },
        ],
        query: {
          bool: {
            must: [
              { match: { account_id: this.account.id } },
            ],
          },
        },
      };
      this.mediaTags.forEach((tag) => {
        const item = {};
        switch (tag._index) {
          case 'doxa_episodes':
            // item.match = { id: tag._id };
            break;
          case 'doxa_channels':
            item.match = { id: tag._id };
            break;
          case 'doxa_episode_collections':
            // item.terms = { collection_ids: [tag._id] };
            break;
          case 'doxa_speakers':
            // item.match = { '_embedded.speaker.id': tag._id };
            break;
          default:
        }
        if (Object.entries(item).length > 0) {
          payload.query.bool.must.push(item);
        }
      });
      return payload;
    },
  },
  created() {
    this.getPage(1);
  },
  data() {
    return {
      pagination: {
        page: 1,
        per: 26,
        total: 0,
      },
      settings: {
        loading: false,
      },
    };
  },
  methods: {
    async getPage(page) {
      this.settings.loading = true;
      this.pagination.page = page;
      const response = await this.$store.dispatch(actions.DO_SEARCH_CHANNELS, this.pageQuery);
      this.pagination.total = response.hits.total;
      this.settings.loading = false;
    },
    async open(channel) {
      await this.$store.dispatch(actions.DO_GET_CHANNEL, {
        id: channel.id,
        zoom: 'artwork',
      });
      this.$buefy.modal.open({
        parent: this,
        component: ChannelForm,
        hasModalCard: true,
      });
    },
    async refresh() {
      const response = await this.$store.dispatch(actions.DO_SEARCH_CHANNELS, this.pageQuery);
      this.$store.commit(mutations.SET_MEDIA_REFRESH, false);
      this.pagination.total = response.hits.total;
    },
  },
  watch: {
    mediaRefresh(val) {
      if (val) this.refresh();
    },
  },
};
</script>

<style lang="scss">
#channels-tab {
  padding: 0 1rem;
}
</style>



// WEBPACK FOOTER //
// src/components/ChannelsTab.vue